import React from "react";
import {Link} from "react-router-dom";

function PastPFDateAndDesc({...props}) {
    return (
        <div>
            Winchester Porchfest 2026 was held on Saturday June 13. Here are some
            of the <Link to="/porchfest-2026" reloadDocument="true">moments</Link> from
            that day.
        </div>
    );
}

export default PastPFDateAndDesc;